import { ComponentProps } from "react"
import { twMerge } from "tailwind-merge"
import { tv, VariantProps } from "tailwind-variants"

type Props = ComponentProps<"div"> & VariantProps<typeof noteStyles>

const noteStyles = tv({
  base: "type-ui-s-roman text-grey-mid",
  variants: {
    danger: {
      true: "text-error-dark",
    },
  },
})

export function Note({ danger, ...props }: Props) {
  if (!props.children) return null
  return <div {...props} className={twMerge(noteStyles({ danger }), props.className)} />
}
